
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import settingx from '@/store/modules/settingx';
import Checkbox from 'primevue/checkbox';

@Component({
	components: { Checkbox },
})
export default class IncludeUnappliedToggle extends Vue {
	@Prop({ default: 'customer' }) public type!: 'customer' | 'supplier';

	public localIncludeUnapplied: boolean = this.globalIncludeUnapplied;

	public get label() {
		return '-Unapplied Amount';
	}

	public get globalIncludeUnapplied() {
		return settingx.now.includeUnapplied;
	}

	@Watch('localIncludeUnapplied')
	public onLocalIncludeUnappliedChanged(newVal) {
		settingx.updateSettings({ includeUnapplied: newVal });
	}

	@Watch('globalIncludeUnapplied')
	public onGlobalIncludeUnappliedChanged(newVal) {
		this.localIncludeUnapplied = newVal;
	}
}
